/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type AddressDtoAddressType = (typeof AddressDtoAddressType)[keyof typeof AddressDtoAddressType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressDtoAddressType = {
  ACCOMMODATION_ASYLUM: 'ACCOMMODATION_ASYLUM',
  ACCOMMODATION_PRIVATE: 'ACCOMMODATION_PRIVATE',
  RELATIVE: 'RELATIVE',
  CONFIDANT: 'CONFIDANT',
  REFERRER: 'REFERRER',
  HOSPITAL: 'HOSPITAL',
  DOT_APPLICANT: 'DOT_APPLICANT',
  DOT_EXECUTOR: 'DOT_EXECUTOR',
  DOCTOR: 'DOCTOR',
  WELFARE_AGENCY: 'WELFARE_AGENCY',
  INSURANCE: 'INSURANCE',
  TB_MEDICAL_CENTER: 'TB_MEDICAL_CENTER',
  PHARMACY: 'PHARMACY',
  LAB: 'LAB',
  CONTACT_REFERENCE_PERSON: 'CONTACT_REFERENCE_PERSON',
} as const;
